import { useForm as useFormHook } from "hooks";
import { BooleanSwitchValue } from "consts/general";
import { parse } from "util/parsers";
import { find, when } from "util/support";
import type { IbanXsBanksCountriesPivot } from "features/openBanking/types";
import {
    FormField,
    type IbanXSBanksCountriesPivotForm,
    type BootstrapData,
    type IbanXSBanksCountriesPivot
} from "./types";
import useValidationSchema from "./useValidationSchema";

export const getInitialValues = ({
    options,
    flow,
    iso2 = '',
    ...restInitialValues
}: Partial<IbanXsBanksCountriesPivot> = {}, bootstrapData: BootstrapData): IbanXSBanksCountriesPivot => ({
    [FormField.Options]: parse(`${options}`, null),
    [FormField.IsEnabled]: BooleanSwitchValue.Off,
    [FormField.ShouldCreditOnRedirect]: BooleanSwitchValue.Off,
    [FormField.BankId]: BooleanSwitchValue.Off,
    [FormField.BankGroup]: null,
    [FormField.LogoUrl]: null,
    [FormField.Iso2]: Array.of(iso2),
    [FormField.Flow]: when(
        flow,
        () => find(bootstrapData.BanksFlows, 'id')(String(flow)),
        flow
    ),
    [FormField.FullName]: '',
    [FormField.Obs]: '',
    [FormField.RecipientsExist]: false,
    ...restInitialValues
});

export const useForm = (ibanXSBanksCountriesPivotForm: IbanXSBanksCountriesPivotForm) =>
    useFormHook({
        enableReinitialize: true,
        ...ibanXSBanksCountriesPivotForm,
        validateOnMount: true,
        validationSchema: useValidationSchema()
    });
